import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setToken, setupConnection } from 'store/core/actions';

const SSOCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refresh_token');
    if (token) {
      // Set expiry to 1 hour from now (matches backend token lifetime)
      const expires_in = Date.now() + 60 * 60 * 1000;

      // Store token using existing action
      dispatch(setToken(token, expires_in, undefined, refreshToken));

      // Setup SignalR connection
      dispatch(setupConnection(token));

      // Check for post-login redirect in sessionStorage (from SSO flow)
      const postLoginRedirect = sessionStorage.getItem('postLoginRedirect');
      if (postLoginRedirect) {
        sessionStorage.removeItem('postLoginRedirect');
        navigate(postLoginRedirect);
      } else {
        // Redirect to home
        navigate('/');
      }
    } else {
      // If no token, redirect to login
      navigate('/login');
    }
  }, [dispatch, navigate, searchParams]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <div className="lds-ring">
        <div></div>
      </div>
    </div>
  );
};

export default SSOCallback;
